/* Minutes treat landing (port) - generated by build/treat-port.py.
   Two jobs: re-arm the scroll reveals React used to add, and drive the plan
   selector. Nothing here is required for the page to be readable or buyable:
   with JS off the page renders fully and posts the subscribe plan. */
(function () {
  var wrap = document.querySelector('[data-treat-port]');
  if (!wrap) return;

  /* --- scroll reveals -------------------------------------------------
     The reveal class carries opacity:0, so it is added ONLY when JS and
     motion are both available - the same condition the React build used.
     Server HTML never contains it, so no-JS can never hide content. */
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var targets = wrap.querySelectorAll('[data-reveal]');
  if (!reduce && 'IntersectionObserver' in window && targets.length) {
    for (var i = 0; i < targets.length; i++) targets[i].classList.add('dirF-reveal');
    var io = new IntersectionObserver(function (entries) {
      for (var k = 0; k < entries.length; k++) {
        if (entries[k].isIntersecting) { entries[k].target.classList.add('is-in'); io.unobserve(entries[k].target); }
      }
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.01 });
    for (var j = 0; j < targets.length; j++) io.observe(targets[j]);
  }

  /* --- plan selector --------------------------------------------------- */
  var form  = document.getElementById('minutes-buy');
  var grid  = wrap.querySelector('[data-plan-grid]');
  if (!form || !grid) return;
  var tiles = grid.querySelectorAll('[role="radio"]');
  if (tiles.length !== 2) return;

  var echo   = wrap.querySelector('.dirF-plan-echo');
  var cta    = document.getElementById('minutes-buy-cta');
  var spIn   = document.getElementById('minutes-selling-plan');
  var rtIn   = document.getElementById('minutes-return-to');
  var sp     = wrap.getAttribute('data-sp') || '';
  var rtSub  = wrap.getAttribute('data-rt-sub') || '/cart';
  var rtOnce = wrap.getAttribute('data-rt-once') || '/cart';
  var hasVariant = !!(form.querySelector('[name="id"]') || {}).value;

  var COPY = {
    sub:  { echo: 'Selected: <b>Subscribe &amp; Save</b>. $29.99 today, then $50 every 4 weeks (37% off, ongoing).',
            aria: 'Start my 28 nights, Subscribe and Save, $29.99 first order' },
    once: { echo: 'Selected: <b>One-Time</b>. $64.99 today, no subscription.',
            aria: 'Start my 28 nights, One-time, $64.99' }
  };

  var current = 'sub';
  function apply(plan) {
    current = plan;
    var sub = plan === 'sub';
    /* wire payload */
    if (spIn) { spIn.disabled = !sub; if (sub) spIn.value = sp; }
    if (rtIn) rtIn.value = sub ? rtSub : rtOnce;
    /* fail closed: subscribe needs a plan, either needs a variant */
    if (cta) cta.disabled = !hasVariant || (sub && !sp);
    /* tiles */
    /* toggle, never assign: className= would wipe dirF-reveal / is-in off the tiles */
    tiles[0].classList.toggle('on', sub);
    tiles[1].classList.toggle('on', !sub);
    tiles[0].setAttribute('aria-checked', sub ? 'true' : 'false');
    tiles[1].setAttribute('aria-checked', sub ? 'false' : 'true');
    if (echo) echo.innerHTML = COPY[plan].echo;
    if (cta) cta.setAttribute('aria-label', COPY[plan].aria);
  }

  /* --- analytics: same events the React trackTreat emitted ------------ */
  function track(event, extra) {
    window.dataLayer = window.dataLayer || [];
    var o = { event: event, variant: 'directionF-treat' };
    for (var k in (extra || {})) o[k] = extra[k];
    window.dataLayer.push(o);
  }
  var ctas = wrap.querySelectorAll('[data-cta]');
  for (var c = 0; c < ctas.length; c++) {
    (function (el) {
      var label = el.getAttribute('data-cta');
      el.addEventListener('click', function () {
        track(label === 'stickybar' ? 'stickybar_clicked' : 'cta_clicked',
              label === 'stickybar' ? {} : { cta: label });
      });
    })(ctas[c]);
  }
  form.addEventListener('submit', function () { track('checkout_start_clicked', { plan: current }); });
  var faqs = wrap.querySelectorAll('details');
  for (var d = 0; d < faqs.length; d++) {
    (function (el) {
      el.addEventListener('toggle', function () {
        if (!el.open) return;
        /* the original emits the question string alone; summary.innerText would
           also swallow the decorative .dirF-faq-ico glyph and break aggregation */
        var sm = el.querySelector('summary'), label = '';
        if (sm) {
          var clone = sm.cloneNode(true);
          var ico = clone.querySelector('.dirF-faq-ico');
          if (ico && ico.parentNode) ico.parentNode.removeChild(ico);
          label = (clone.textContent || '').replace(/\s+/g, ' ').trim();
        }
        track('faq_opened', { q: label });
      });
    })(faqs[d]);
  }
  var mail = wrap.querySelector('.dirF-foot-mail');
  if (mail) mail.addEventListener('submit', function () { track('email_submitted', {}); });

  /* --- sticky buy bar: show once the hero is gone and #buy is not in view
     (mirrors StickyBuyBar in direction-f-treat-b.jsx:1573-1592) --------- */
  var bar = wrap.querySelector('.dirF-stickybar');
  var hero = wrap.querySelector('.dirF-hero');
  var buySec = document.getElementById('buy');
  if (bar && hero && buySec && 'IntersectionObserver' in window) {
    var heroGone = false, buyVisible = false;
    var barCta = bar.querySelector('a');
    var setBar = function (on) {
      bar.classList.toggle('show', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      if (barCta) barCta.setAttribute('tabindex', on ? '0' : '-1');
    };
    setBar(false);
    var bio = new IntersectionObserver(function (entries) {
      for (var i2 = 0; i2 < entries.length; i2++) {
        if (entries[i2].target === hero) heroGone = !entries[i2].isIntersecting;
        if (entries[i2].target === buySec) buyVisible = entries[i2].isIntersecting;
      }
      setBar(heroGone && !buyVisible);
    }, { threshold: 0 });
    bio.observe(hero); bio.observe(buySec);
  }

  var ORDER = ['sub', 'once'];
  /* every selection - pointer or keyboard - goes through pick(), which is the
     only place that both applies state and emits the funnel event. */
  function pick(plan) { apply(plan); track('buybox_tile_selected', { plan: plan }); }
  function bind(el, plan, idx) {
    el.addEventListener('click', function () { pick(plan); });
    el.addEventListener('keydown', function (e) {
      var k = e.key, other = (idx + 1) % 2;
      if (k === 'Enter' || k === ' ' || k === 'Spacebar') { e.preventDefault(); pick(plan); return; }
      if (k === 'ArrowRight' || k === 'ArrowDown' || k === 'ArrowLeft' || k === 'ArrowUp') {
        e.preventDefault(); tiles[other].focus(); pick(ORDER[other]);
      }
    });
  }
  /* footer signup confirmation - the React build rendered this when Shopify
     redirects back with ?customer_posted=true (build/treat-build.mjs:67) */
  if (/customer_posted=true/.test(location.search)) {
    var mailForm = wrap.querySelector('.dirF-foot-mail');
    if (mailForm && !mailForm.querySelector('[role="status"]')) {
      var st = document.createElement('div');
      st.setAttribute('role', 'status');
      st.style.marginTop = '8px';
      st.style.opacity = '0.8';
      st.textContent = 'Thanks. You are on the list.';
      mailForm.appendChild(st);
    }
  }

  bind(tiles[0], 'sub', 0);
  bind(tiles[1], 'once', 1);
  apply('sub');
})();
